const NumberIndicator = ({ number }: { number: number }) => {
  return (
    <span className='px-1 py-0.5 min-w-[1.4rem] bg-destructive rounded-full text-xs text-white flex items-center justify-center font-semibold border border-muted'>
      {number}
    </span>
  )
}

export default NumberIndicator
